import React, { memo } from 'react'
import AppFormikInputInline from 'utlis/helpers/forms/AppFormikInputInline'
import AppFormikSelectInline from 'utlis/helpers/forms/AppFormikSelectInline'

function FormCustomerGroups__Details(props) {
    const { formik } = props
    return (
        <React.Fragment>

            <AppFormikInputInline
                formik={formik}
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center mb-1"}
                labelName={"Group Name"}
                isRequired={true}
                placeholder={"Group Name"}
                formikFieldName={"group_name"}
            />

            <AppFormikSelectInline
                formik={formik}
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center mb-1"}
                labelName={"Discount Percent"}
                isRequired={false}
                formikFieldName={"discount_percent"}
            >
                <option disabled value="">Select Discount Percent</option>
                <option value="1">Yes</option>
                <option value="0">No</option>
            </AppFormikSelectInline>

            <AppFormikInputInline
                formik={formik}
                stFormClass={"st-form-with-label-left no-arrows d-flex flex-wrap align-items-center mb-1"}
                labelName={"Discount Value"}
                isRequired={false}
                placeholder={"Discount Value"}
                formikFieldName={"discount_value"}
                inputType="number"
            />

            <AppFormikSelectInline
                formik={formik}
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center mb-1"}
                labelName={"Status"}
                isRequired={false}
                formikFieldName={"active"}
            >
                <option >Select Status</option>
                <option value="1">Active</option>
                <option value="0">Inactive</option>
            </AppFormikSelectInline>

        </React.Fragment>
    )
}

export default memo(FormCustomerGroups__Details)